export type PartnerCheckInMarkerRecord = {
  checkin_active?: boolean
  finished?: boolean
}

export const shouldShowPartnerCheckInMarker = (
  partner: PartnerCheckInMarkerRecord
) => partner.finished === true || partner.checkin_active === true

export const isPartnerCheckInDone = (partner: PartnerCheckInMarkerRecord) =>
  partner.finished === true
